<form class="flex flex-col gap-6" (submit)="submit($event)">
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      Tell us about your <span class="text-primary">agency</span>
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Two details. You can add more later.</p>
  </div>

  <div class="flex flex-col gap-2">
    <label for="vfa-agency-name" class="text-base font-bold">Agency name</label>
    <input
      id="vfa-agency-name"
      type="text"
      placeholder="Your agency"
      class="h-14 rounded-lg border border-border bg-card px-4 text-lg text-foreground outline-none placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20"
      [class.border-red-600]="onboarding.error()"
      [value]="name()"
      (input)="onName($event)" />
  </div>

  <fieldset class="m-0 flex flex-col gap-2 border-0 p-0">
    <legend class="text-base font-bold">Operating currency</legend>
    <div class="grid grid-cols-3 gap-2">
      @for (currency of currencies; track currency) {
        <button
          type="button"
          class="h-12 rounded-lg border text-lg font-bold"
          [class]="onboarding.activeCurrency() === currency ? 'border-primary bg-primary text-primary-foreground' : 'border-border bg-card text-foreground'"
          (click)="chooseCurrency(currency)">
          {{ currency === 'GBP' ? '£ GBP' : currency === 'USD' ? '$ USD' : '€ EUR' }}
        </button>
      }
    </div>
  </fieldset>

  @if (onboarding.error()) {
    <p class="m-0 text-base font-semibold text-red-600 dark:text-red-400" role="alert">{{ onboarding.error() }}</p>
  }

  <div class="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background px-5 py-3 sm:static sm:z-auto sm:border-0 sm:bg-transparent sm:p-0">
    <button type="submit" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center">Continue →</button>
  </div>
</form>
